import React, { useReducer, useEffect } from 'react';
import { Col, Row, Slider, Divider } from 'antd';

import { DEFAULT_SHADOW_BORDER_COLOR } from 'constants/colors';
import HueSlider from '../HueSlider/HueSlider';

const initialState = {
  borderWidth: 0,
  borderRadius: 0,
  borderColor: { ...DEFAULT_SHADOW_BORDER_COLOR },
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'setBorderWidth':
      return { ...state, borderWidth: action.borderWidth };
    case 'setBorderRadius':
      return { ...state, borderRadius: action.borderRadius };
    case 'setBorderColor':
      return { ...state, borderColor: action.borderColor };
    case 'reset':
      return initialState;
    default:
      throw new Error('Unexpected action');
  }
};

const BorderPicker = ({ border, onChange }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    if (border) {
      dispatch({ type: 'setBorderWidth', borderWidth: border?.borderWidth });
      dispatch({ type: 'setBorderRadius', borderRadius: border?.borderRadius });
      dispatch({ type: 'setBorderColor', borderColor: border?.borderColor });
    }
  }, []); //eslint-disable-line

  const handleChange = (value, dispatchType, stateType) => {
    dispatch({ type: dispatchType, [stateType]: value });
    onChange({ ...state, [stateType]: value });
  };

  return (
    <Row className="border-picker" gutter={16}>
      <Col span={24}>
        <h4>Border</h4>
      </Col>
      <Col className="gutter-row" span={12}>
        <small className="image-crop-label">Border Width {state.borderWidth}</small>
        <Slider
          step={1}
          min={0}
          max={20}
          value={state.borderWidth}
          onChange={(value) => handleChange(value, 'setBorderWidth', 'borderWidth')}
          tooltipVisible={false}
        />
      </Col>
      <Col className="gutter-row" span={12}>
        <small className="image-crop-label">Border Radius {state.borderRadius}</small>
        <Slider
          step={1}
          min={0}
          max={160}
          value={state.borderRadius}
          onChange={(value) => handleChange(value, 'setBorderRadius', 'borderRadius')}
          tooltipVisible={false}
        />
      </Col>
      <Divider />
      <Col className="gutter-row" span={24}>
        <HueSlider
          value={state.borderColor}
          onChange={(value) => handleChange(value, 'setBorderColor', 'borderColor')}
        />
      </Col>
    </Row>
  );
};

export default BorderPicker;
